import { ExperimentOutlined } from '@ant-design/icons';
import { useAuth } from '../lib/auth';

/**
 * Always-visible banner shown in tabs that are running a preview-as-speaker
 * session, so the admin doesn't forget they're driving a fake account.
 */
export function PreviewBanner() {
  const { isPreview, session } = useAuth();
  if (!isPreview) return null;
  return (
    <div
      style={{
        background: '#fff7e6',
        borderBottom: '1px solid #ffd591',
        color: '#874d00',
        fontSize: 12,
        padding: '6px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        position: 'sticky',
        top: 0,
        zIndex: 1100,
      }}
    >
      <ExperimentOutlined />
      <span>
        <strong>Preview mode</strong> — you're impersonating <code>{session?.email}</code>{' '}
        in this tab only. Close the tab to end the preview.
      </span>
    </div>
  );
}
